// global.BaseUrl =
//   "https://foodweb-saiga.ksoftpl.com/foodweb-saiga-backend/public/api";
// global.AssetsUrl =
//   "https://foodweb-saiga.ksoftpl.com/foodweb-saiga-backend/public";

global.BaseUrl =
  "https://admin.foodweb-saiga.ksoftpl.com/api";
global.AssetsUrl =
  "https://admin.foodweb-saiga.ksoftpl.com";
